class YouTubeApiLoader {
  constructor() {
    if (!YouTubeApiLoader.instance) {
      this.ready = false;
      this.players = [];
      this.load();

      YouTubeApiLoader.instance = this;
    }

    return YouTubeApiLoader.instance;
  }

  load() {
    if (this.ready) return;

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      this.ready = true;
      this.players.forEach(player => player.init());
    };
  }

  addPlayer(player) {
    console.log(this.ready);
    console.log(player);
    if (this.ready) {
      player.init();
    } else {
      this.players.push(player);
    }
  }
}

export class YouTubePlayer {
  constructor(selector, videoId, options = {}) {
    this.selector = selector;
    this.videoId = videoId;
    this.options = options;
    this.player = null;

    // Use the singleton to load YouTube API, then initialize the player.
    this.apiLoader = new YouTubeApiLoader();
    this.apiLoader.addPlayer(this);
  }

  init() {
    const container = document.querySelector(this.selector);
    if (container === null) throw new Error(`Container not found: ${this.selector}`);

    this.player = new YT.Player(container, {
      videoId: this.videoId,
      ...this.options,
    });

    console.log(this.player);
  }

  play() {
    if (this.player) this.player.playVideo();
  }

  pause() {
    if (this.player) this.player.pauseVideo();
  }
}
